export const MOBILE_CONSTRUCTION = 'mobile_under_construction';
export const TIMES_USER_SEEN_MORE_ARROW_COOKIE = 'TIMES_USER_SEEN_MORE_ARROW_COOKIE';
export const PHOTO_TOOLTIP_HELPER_CLOSED_COOKIE = 'PHOTO_TOOLTIP_HELPER_CLOSED_COOKIE';
export const CSRF_TOKEN = 'CSRF-TOKEN';
export const PAYMENTS_INTRO_COOKIE = 'PAYMENTS_INTRO_COOKIE';
export const LITTERS_ENABLE_PAYMENTS_COOKIE = 'LITTERS_ENABLE_PAYMENTS_COOKIE';
